import {
  FactorCombinationPiSuggestedTopic,
  FactorPiSuggestedTopic,
  GeneralPiSuggestedTopic,
  PiSuggestedTopicsCategories,
  PiSuggestedTopicType,
} from 'Shared/types/PiSuggestedTopic.type';

export const GeneralPiSuggestedTopics: GeneralPiSuggestedTopic[] = [
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: "Let's discuss current gaps in the team's communication.",
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: 'When you need support, would you prefer to reach out or have me check in regularly?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: "What's one way we could make this meeting more efficient moving forward?",
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: 'Are there any stakeholders or departments you’d like more interaction with?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: "Let's discuss our current method(s) of communication. What's working, and what could be improved?",
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.communication,
    suggestion:
      'Would you prefer connecting face to face when possible or asyncronously (e.g., via email or messages)?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: 'Have we been connecting frequently enough? Would you like to increase or reduce this frequency?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: "Do you prefer keeping our time to connect even when we don't have formal topics to discuss? ",
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: 'Is there anything else you wanted to talk about today?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: 'Do you prefer detailed meeting notes, or should we keep it high-level?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: 'Tell me where you want to go with this [task, project, initiative].',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: "What's going well right now in your work? Where could you use support?",
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: 'What are you most proud of this week? Tell me about your recent wins, accomplishments, etc.',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: 'What kinds of feedback are we getting on this [task, project, idea]?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: 'What elements of the work are frustrating or demotivating? How can we address those?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: 'Are there any [tasks, projects, initiatives] that you need more clarity or information on?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: 'What are some recent changes or developments you have questions about?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion:
      'What are some things you are working on that we can promote or celebrate within the team/organization?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: 'What decisions can we commit to today?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: 'How are your longer-term projects progressing?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'Is there anything with work or in general that you have questions or concerns about?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'How do you prefer to receive recognition: publicly, privately, or a mix of both?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'If you could change anything about how we interact, what would it be?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'How are you feeling on a scale from 1 to 10? How can I help improve that number?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'What’s an example of something we do really well as a team?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'What should we start doing to improve our team dynamic?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'What are some ways we can create a more inclusive and welcoming team environment?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'What’s something positive—no matter how big or small—that’s happened since we last met?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'What are your current goals or priorities? How have things progressed lately?',
  },
  {
    type: PiSuggestedTopicType.general,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'What are some ways we can better support one another in our 1:1 conversations?',
  },
];

export const FactorPiSuggestedTopics: FactorPiSuggestedTopic[] = [
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: "What challenging ideas, concerns, or feedback haven't we discussed?",
    factor: 'A',
    sigmaZonePlacement: 'high',
    basedOn: "%first_name%'s comfort with conflict",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: 'How can we leave a lasting, identifiable impact on this [project, initiative, goal]?',
    factor: 'A',
    sigmaZonePlacement: 'high',
    basedOn: "%first_name%'s need for ownership",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'How can I support your big ideas?',
    factor: 'A',
    sigmaZonePlacement: 'high',
    basedOn: "%first_name%'s venturesome nature",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: 'What are you excited to talk about today?',
    factor: 'B',
    sigmaZonePlacement: 'high',
    basedOn: "%first_name%'s high level of enthusiasm",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: "How can I make sure your process isn't disrupted when I reach out?",
    factor: 'C',
    sigmaZonePlacement: 'high',
    basedOn: "%first_name%'s need for stability",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.communication,
    suggestion: 'What details or data points we should discuss for this [task, project, deliverable]?',
    factor: 'D',
    sigmaZonePlacement: 'high',
    basedOn: "%first_name%'s need for structure",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: 'What additional information do we need to get this work done?',
    factor: 'D',
    sigmaZonePlacement: 'high',
    basedOn: "%first_name%'s meticulous nature",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: 'How can we draw more attention to this [task, project, initiative]?',
    factor: 'B',
    sigmaZonePlacement: 'high',
    basedOn: "%first_name%'s need for public recognition",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    suggestion: 'How can we standardize or break down this [task, project, process] to reduce distractions?',
    factor: 'C',
    sigmaZonePlacement: 'high',
    basedOn: "%first_name%'s need for a steady pace",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'What are some ways to energize this [space, group, team]?',
    factor: 'B',
    sigmaZonePlacement: 'high',
    basedOn: "%first_name%'s need for connection",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'Are there any recent changes that you are still adjusting to?',
    factor: 'C',
    sigmaZonePlacement: 'high',
    basedOn: "%first_name%'s need for stability",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.relationship_building,
    suggestion: 'Help me consider the benefits and drawbacks of this [idea, approach, decision].',
    factor: 'D',
    sigmaZonePlacement: 'high',
    basedOn: "%first_name%'s meticulous thinking",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.communication,
    factor: 'A',
    sigmaZonePlacement: 'low',
    basedOn: "%first_name%'s need for team consensus",
    suggestion: 'How do we make sure the group is informed and bought into this [task, project, idea]?',
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    factor: 'A',
    sigmaZonePlacement: 'low',
    basedOn: "%first_name%'s need for collaboration",
    suggestion: "Are there any [projects, tasks, ideas] that you'd like support on?",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.relationship_building,
    factor: 'A',
    sigmaZonePlacement: 'low',
    basedOn: "%first_name%'s need for collaboration",
    suggestion: 'How well do we feel the team is working together?',
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.communication,
    factor: 'B',
    sigmaZonePlacement: 'low',
    basedOn: "%first_name%'s need for reflection",
    suggestion: 'What items should we revisit next time we meet so you have more time to reflect?',
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    factor: 'B',
    sigmaZonePlacement: 'low',
    basedOn: "%first_name%'s need for introspection",
    suggestion: 'What kinds of information or facts have we not reflected on?',
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.relationship_building,
    factor: 'B',
    sigmaZonePlacement: 'low',
    basedOn: "%first_name%'s tendency to reflect",
    suggestion: 'What [ideas, problems, questions] have been on your mind lately?',
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.communication,
    factor: 'C',
    sigmaZonePlacement: 'low',
    basedOn: "%first_name%'s driving nature",
    suggestion: 'What are some ways we can communicate about urgent matters?',
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    factor: 'C',
    sigmaZonePlacement: 'low',
    basedOn: "%first_name%'s preference for multiple priorities",
    suggestion: "What opportunities are there to add variety to the work we're doing?",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.relationship_building,
    factor: 'C',
    sigmaZonePlacement: 'low',
    basedOn: "%first_name%'s appreciation for change",
    suggestion: 'What are some immediate changes I can help you drive?',
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.communication,
    factor: 'D',
    sigmaZonePlacement: 'low',
    basedOn: "%first_name%'s need for big-picture thinking",
    suggestion: "Do you have any high-level ideas or goals you'd like to discuss today?",
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    factor: 'D',
    sigmaZonePlacement: 'low',
    basedOn: "%first_name%'s flexible nature",
    suggestion: 'What are some unconventional ways we can approach this [idea, task, project]?',
  },
  {
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.relationship_building,
    factor: 'D',
    sigmaZonePlacement: 'low',
    basedOn: "%first_name%'s flexible thinking",
    suggestion: 'If we could do things differently, what would you change?',
  },
  {
    sigmaZonePlacement: 'situational',
    factor: 'A',
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s situational need for autonomy",
    suggestion: 'Who are the right stakeholders and how do we establish a feedback loop with them?',
  },
  {
    sigmaZonePlacement: 'situational',
    factor: 'A',
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s situational need for autonomy",
    suggestion: 'Which parts of this [task, project] should we work on independently? Which should we collaborate on?',
  },
  {
    sigmaZonePlacement: 'situational',
    factor: 'A',
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s situational need for independent achievement",
    suggestion: 'How can we support the team while also celebrating individual goals?',
  },
  {
    sigmaZonePlacement: 'situational',
    factor: 'B',
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s situational need to talk things out",
    suggestion: 'How can we ensure our meeting allows for both live conversation and in-the-moment reflection?',
  },
  {
    sigmaZonePlacement: 'situational',
    factor: 'B',
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s situational need for reflection",
    suggestion:
      "Would you like to discuss this [task, project, idea] now or revisit it once you'd had time to reflect?",
  },
  {
    sigmaZonePlacement: 'situational',
    factor: 'B',
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s situational extraversion drive",
    suggestion: 'Do we want more time face to face, or would you prefer time to reflect?',
  },
  {
    sigmaZonePlacement: 'situational',
    factor: 'C',
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s situational need for routine",
    suggestion: "Let's talk through what needs to be prioritized today.",
  },
  {
    sigmaZonePlacement: 'situational',
    factor: 'C',
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s varying level of urgency",
    suggestion: 'How quickly or steadily should we approach this [task, project, deliverable]?',
  },
  {
    sigmaZonePlacement: 'situational',
    factor: 'C',
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s situational need for variety",
    suggestion: 'How can we maintain our routines, while remaining open to new ways of doing things?',
  },
  {
    sigmaZonePlacement: 'situational',
    factor: 'D',
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s varying need for specifics",
    suggestion: 'How deep into the details do we want to go for this [task, project, deliverable]?',
  },
  {
    sigmaZonePlacement: 'situational',
    factor: 'D',
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s situational need for flexibility",
    suggestion: 'How do you feel about the current balance of flexibility and structure in your work?',
  },
  {
    sigmaZonePlacement: 'situational',
    factor: 'D',
    type: PiSuggestedTopicType.factor,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s situational level of spontaneity",
    suggestion: 'How can we welcome spontaneous ideas, while also carefully determining which are worth following?',
  },
];

export const FactorCombinationPiSuggestedTopics: FactorCombinationPiSuggestedTopic[] = [
  {
    combination: 'A over B',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s problem-solving nature",
    suggestion: "Tell me how you're currently approaching this [task, project, problem].",
  },
  {
    combination: 'A over B',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s creative thinking",
    suggestion: 'What tasks or problems are you grappling with lately?',
  },
  {
    combination: 'A over B',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s inquiring mind",
    suggestion: 'Do you have any [ideas, questions, solutions] that I can help you test or refine?',
  },
  {
    combination: 'A over C',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s need to take initiative",
    suggestion: 'What emerging [ideas, issues, trends] should we start discussing further?',
  },
  {
    combination: 'A over C',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s positive response to pressure",
    suggestion: "What roadblocks haven't we accounted for?",
  },
  {
    combination: 'A over C',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s proactive nature",
    suggestion: "What are some things you're hoping to take initiative on this [month, quarter, year]?",
  },
  {
    combination: 'A over D',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s drive to innovate",
    suggestion: "Let's discuss some ways we can challenge existing norms.",
  },
  {
    combination: 'A over D',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s decisive nature",
    suggestion: 'What [steps, decisions, ideas] can we commit to today, despite the risks?',
  },
  {
    combination: 'A over D',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s venturesome nature",
    suggestion: 'What [ventures, risks, big bets] have you been exploring lately?',
  },
  {
    combination: 'B over A',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s empathetic, people-oriented nature",
    suggestion: 'How can we enhance the general sentiment around this [task, project, event]?',
  },
  {
    combination: 'B over A',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s people-oriented nature",
    suggestion: 'What are some ways we can bring people together to collaborate on this [task, project, idea]?',
  },
  {
    combination: 'B over A',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s sociable nature",
    suggestion: 'What are some ways we can help team members get to know each other better?',
  },
  {
    combination: 'B over C',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s optimistic nature",
    suggestion: 'What are some ways we can get others excited and energized about this [task, project, idea]?',
  },
  {
    combination: 'B over C',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s persuasive, motivating nature",
    suggestion: 'How can we show stakeholders why this [idea, project, initiative] is worth pursuing?',
  },
  {
    combination: 'B over C',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s level of optimism and liveliness",
    suggestion: "What's something you've been excited about lately?",
  },
  {
    combination: 'B over D',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s level of enthusiasm",
    suggestion: "Talk to me about an [idea, event, initiative] you'd love others to know about.",
  },
  {
    combination: 'B over D',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s open, outgoing nature",
    suggestion: 'How can we socialize this [idea, project, initiative] and crowdsource feedback?',
  },
  {
    combination: 'B over D',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s appreciation for casual conversation",
    suggestion: "How's your week going outside of work?",
  },
  {
    combination: 'C over A',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s high level of responsiveness",
    suggestion: 'Are there any items we can take the time to respond to now?',
  },
  {
    combination: 'C over A',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s need for steadiness and predictability",
    suggestion: 'How are we feeling about recent changes to this [work, project, team]?',
  },
  {
    combination: 'C over A',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s high level of steadiness",
    suggestion: 'What are some ways for us to provide stability and calm, even when things are uncertain?',
  },
  {
    combination: 'C over B',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s preference for routine connection",
    suggestion: 'What [tasks, ideas, projects] are particularly important for us to keep a strong touchpoint on?',
  },
  {
    combination: 'C over B',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s preference to think before speaking",
    suggestion: 'What topics do we want to revisit next time so you can have more time for careful thought?',
  },
  {
    combination: 'C over B',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s comfort with established connections",
    suggestion: "How can I make sure we're taking time to carefully consider your thoughts and elevate your ideas?",
  },
  {
    combination: 'C over D',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s stability and persistence",
    suggestion: 'How can we help the team navigate ambiguous [guidelines, rules, processes]?',
  },
  {
    combination: 'C over D',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s casual treatment of rules",
    suggestion: 'Are there rules we could bypass that will ease this process?',
  },
  {
    combination: 'C over D',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s casual nature",
    suggestion: 'Where could we be more flexible or relaxed in our approach?',
  },
  {
    combination: 'D over A',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s careful and supportive nature",
    suggestion: 'Can you help me explore potential [drawbacks, missteps, or criticisms] pertaining to this work?',
  },
  {
    combination: 'D over A',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s need for accuracy and careful execution",
    suggestion: 'What risks are associated with this [task, project, initiative]? How can we mitigate that risk?',
  },
  {
    combination: 'D over A',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s need for structure",
    suggestion: 'What are some ways we can enhance planning for our regular touchpoints?',
  },
  {
    combination: 'D over B',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s need for precision and formality",
    suggestion: 'How we can incorporate more structure in our communications around this [task, project, initiative]?',
  },
  {
    combination: 'D over B',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s formal, analytical nature",
    suggestion: 'How can we leverage data, facts, and careful reflection to improve this work?',
  },
  {
    combination: 'D over B',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s serious approach to criticism",
    suggestion: 'How do you prefer to receive feedback?',
  },
  {
    combination: 'D over C',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.communication,
    basedOn: "%first_name%'s desire to be punctual and accurate",
    suggestion: 'Are they any [details, specifics, dates] we should follow up on before our next meeting?',
  },
  {
    combination: 'D over C',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.day_to_day_work,
    basedOn: "%first_name%'s need for precision",
    suggestion: 'What are some opportunities to improve clarity, refine expectations, or increase efficiency?',
  },
  {
    combination: 'D over C',
    type: PiSuggestedTopicType.factorCombination,
    category: PiSuggestedTopicsCategories.relationship_building,
    basedOn: "%first_name%'s need for precision and follow-up",
    suggestion: "How can we ensure that we don't leave out any details or dependencies when we connect?",
  },
];
